export default "__VITE_ASSET__By_nl5k6__"